import React from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../context/ThemeContext";
import { useContext } from "react";

const LanguageSettings = () => {
  const { i18n } = useTranslation();
  const { changeDirectionLayout } = useContext(ThemeContext);

  const currentLang = i18n.language?.split("-")[0] || "ar";

  const handleChange = (e) => {
    const value = e.target.value;

    i18n.changeLanguage(value);
    localStorage.setItem("i18nextLng", value);

    changeDirectionLayout({
      value: value === "ar" ? "rtl" : "ltr",
    });
  };

  

  return (
    <div className="col-sm-6">
      <p>Language</p>
      <select
        className="form-control"
        value={currentLang}
        onChange={handleChange}
      >
        <option value="ar">العربية</option>
        <option value="en">English</option>
      </select>
    </div>
  );
};

export default LanguageSettings;
